import GenericSection from '@layouts/sections/GenericSection';

import { REPORT_SCROLL_ID } from '@common/configs';
import Subsection from '@components/Subsection';

import { useVisibleSections } from './hooks';
import sectionComponents, { type IReportContentProps } from './types';

import style from './styles.module.scss';

const ReportContent = ({ sectionData: sections = [], slideRefs }: IReportContentProps) => {
  const { visibleSubSections } = useVisibleSections(slideRefs, sections);

  return (
    <div
      className={style.sections}
      data-scroll-target={REPORT_SCROLL_ID}
    >
      {sections.map((section) => {
        const SectionComponent = sectionComponents[section.id];
        const refElement = slideRefs.get(section.id);
        const isVisible = visibleSubSections.has(section.id);

        return (
          <section
            key={section.id}
            id={section.id}
            className={style.section}
          >
            {!SectionComponent ? (
              <GenericSection
                sectionData={section}
                slideRefs={slideRefs}
                visibleSubSections={visibleSubSections}
              />
            ) : (
              <Subsection
                key={section.id}
                id={section.id}
                refElement={refElement}
                isVisible={isVisible}
                contentComponent={
                  <SectionComponent
                    sectionData={section}
                    slideRefs={slideRefs}
                    visibleSubSections={visibleSubSections}
                  />
                }
              />
            )}
          </section>
        );
      })}
    </div>
  );
};

export default ReportContent;
